"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../scss/InPageNavigation.scss");
require("./modules/inpagenavigation");
